import { render, staticRenderFns } from "./UpdateTrkPage.vue?vue&type=template&id=7408b812"
import script from "./UpdateTrkPage.vue?vue&type=script&lang=js"
export * from "./UpdateTrkPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports